module.exports = "/static/assets/1cd8bd83990ffb15273e8df1a36757e5.svg";